export default "__VITE_ASSET__M_E8DIzZ__"